import { saveProgress } from "../../services/player.service";
export var generateSource = function (mappers, quality) {
    if (quality === void 0) { quality = "SD"; }
    var source = {
        src: "",
        license: "",
    };
    var mapper = mappers.find(function (item) { return item.quality === quality && item.drm === "none"; });
    if (!mapper) {
        console.log("Mapper not found");
        return;
    }
    source.src = "/api/v1/stream/" + mapper.id + "/";
    return source;
};
export var getProgresStats = function (videoRef, oldState) {
    if (!videoRef) {
        return;
    }
    var currentTimeSeconds = videoRef.currentTime;
    var durationSeconds = videoRef.duration;
    var currentHours = Math.floor(currentTimeSeconds / 3600);
    var currentMinutes = Math.floor((currentTimeSeconds % 3600) / 60);
    var currentSeconds = Math.floor(currentTimeSeconds % 60);
    var formatTime = function (hours, minutes, seconds) {
        var paddedMinutes = minutes < 10 ? "0" + minutes : minutes;
        var paddedSeconds = seconds < 10 ? "0" + seconds : seconds;
        return hours > 0
            ? hours + ":" + paddedMinutes + ":" + paddedSeconds
            : minutes + ":" + paddedSeconds;
    };
    var timeLeftSeconds = durationSeconds - currentTimeSeconds;
    var leftHours = Math.floor(timeLeftSeconds / 3600);
    var leftMinutes = Math.floor((timeLeftSeconds % 3600) / 60);
    var leftSeconds = Math.floor(timeLeftSeconds % 60);
    var progress = durationSeconds > 0 ? currentTimeSeconds / durationSeconds : 0;
    return {
        timeLeftSide: formatTime(currentHours, currentMinutes, currentSeconds),
        timeRightSide: formatTime(leftHours, leftMinutes, leftSeconds),
        progress: progress,
    };
};
export var updateProgress = function (videoRef, playerState) {
    var segments = getPlayedSegments(videoRef, playerState.playedSegments);
    var data = {
        movieId: playerState.movieId,
        episodeId: playerState.episodeId,
        profileId: playerState.profileId,
        progress: playerState.progress,
        language: playerState.language,
        caption: playerState.caption,
        currentTime: videoRef.current.currentTime,
        quality: playerState.quality,
        origin: "silk",
        watchSessionId: playerState.watchSessionId,
        playedSegments: segments,
    };
    saveProgress(data);
};
var getPlayedSegments = function (videoRef, playedSegments) {
    var timeRanges = videoRef.current.played;
    var result = [];
    for (var i = 0; i < timeRanges.length; i++) {
        result.push(timeRanges.start(i) + " " + timeRanges.end(i));
    }
    var merged = playedSegments.concat(result);
    var deduplicatedSegments = Array.from(new Set(merged));
    return deduplicatedSegments;
};
export var getLastPlayed = function (episodes) {
    if (!episodes || episodes.length === 0) {
        return;
    }
    return episodes
        .map(function (episode) {
        if (episode.watchHistory && episode.watchHistory.updatedAt) {
            episode.watchHistory.updatedAt = new Date(episode.watchHistory.updatedAt);
        }
        return episode;
    })
        .reduce(function (lastWatchedEpisode, currentEpisode) {
        if (currentEpisode.watchHistory &&
            !currentEpisode.watchHistory.updatedAt) {
            return lastWatchedEpisode;
        }
        if (lastWatchedEpisode.watchHistory &&
            !lastWatchedEpisode.watchHistory.updatedAt) {
            return currentEpisode;
        }
        if (currentEpisode.watchHistory && lastWatchedEpisode.watchHistory) {
            if (currentEpisode.watchHistory.updatedAt >
                lastWatchedEpisode.watchHistory.updatedAt) {
                return currentEpisode;
            }
        }
        return lastWatchedEpisode;
    });
};
export var getNextEpisode = function (episodes, id) {
    var index = episodes.findIndex(function (episode) { return episode.id === id; });
    var nextEpisode = episodes[index + 1];
    if (nextEpisode && nextEpisode.status !== "CS") {
        return { isLast: false, id: nextEpisode.id };
    }
    return { isLast: true };
};



//////////////////
// WEBPACK FOOTER
// ./src/screens/Player/PlayerService.ts
// module id = 42
// module chunks = 1